import { render, staticRenderFns } from "./agora-live.vue?vue&type=template&id=acf3f48a&scoped=true&"
import script from "./agora-live.vue?vue&type=script&lang=js&"
export * from "./agora-live.vue?vue&type=script&lang=js&"
import style0 from "./agora-live.vue?vue&type=style&index=0&id=acf3f48a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf3f48a",
  null
  
)

/* custom blocks */
import block0 from "./agora-live.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports